/* SS - de bitene av felles-drakten (assets/ss-overlay.css) som ikke kan gjøres i CSS alene.
   Kristoffer/Claude 23.09.2026.

   To ting:
   1) Cart-draweren hadde ingen LUKKE-animasjon: gCloseCart() satte visibility:hidden med en gang,
      så skuffen forsvant i ett hopp mens den gled pent inn. Vi legger på .g-cart-closing, lar
      animasjonen gå ferdig, og kaller så den opprinnelige funksjonen.
   2) Prishistorikk-modalen eies av Compliance Tracker-appen. Den åpnes/lukkes med inline
      display:flex|none. Åpningen animerer CSS selv (animation kjører når display endres), men
      lukkingen rekker ikke - derfor fanger vi klikket på X-en og bakgrunnen i CAPTURE-fasen,
      spiller ut-animasjonen, og gjør så nøyaktig det appens closeModal() gjør.
      Samme sted setter vi overskriften til appens egen «Prishistorikk» i stedet for produktnavnet,
      slik at arket har samme hode som «Shop the look». Teksten hentes fra appens egen
      konfigurasjon ([data-pht-config].t.popupTitle), så den er riktig i hver butikk. */
(function () {
  if (window.__ssOverlay) return;
  window.__ssOverlay = true;

  var PANEL_MS = 300;                                   /* ark, = --ss-panel-dur */
  var POP_MS = 180;                                     /* sentrert pop-up paa desktop */
  function isPhone() { return window.matchMedia('(max-width:767px)').matches; }

  /* ---------- 1) cart: lukke-animasjon ---------------------------------- */
  function wrapCartClose() {
    if (typeof window.gCloseCart !== 'function' || window.gCloseCart.__ss) return false;
    var orig = window.gCloseCart;
    function wrapped() {
      var content = document.querySelector('#g-cart-content');
      if (!content || !content.classList.contains('g-cart-open')) { orig(); return; }
      content.classList.remove('g-cart-open');
      content.classList.add('g-cart-closing');
      setTimeout(function () {
        content.classList.remove('g-cart-closing');
        orig();
        /* orig() setter body.style.overflow = 'auto'. Staar prishistorikk-arket aapent, ville det
           laast opp under foettene paa det - samme delte felt som over. */
        var ph = document.querySelector('.price-history-modal');
        if (ph && getComputedStyle(ph).display !== 'none' && ph.offsetHeight > 0) {
          document.body.style.overflow = 'hidden';
        }
      }, PANEL_MS);
    }
    wrapped.__ss = true;
    window.gCloseCart = wrapped;
    return true;
  }
  /* seksjonens inline-script kjører før denne (defer), men temaeditoren laster seksjonen på nytt */
  if (!wrapCartClose()) {
    var tries = 0;
    var t = setInterval(function () { if (wrapCartClose() || ++tries > 20) clearInterval(t); }, 250);
  }
  document.addEventListener('shopify:section:load', wrapCartClose);

  /* ---------- 2) prishistorikk: hode + lukke-animasjon ------------------- */
  function phTitle(tracker) {
    var cfg = tracker.querySelector('script[data-pht-config]');
    if (!cfg) return '';
    try { return (JSON.parse(cfg.textContent).t || {}).popupTitle || ''; } catch (e) { return ''; }
  }

  function setHeads() {
    document.querySelectorAll('.price-history-tracker').forEach(function (tracker) {
      var h3 = tracker.querySelector('.price-history-modal .modal-header h3');
      if (!h3) return;
      var title = phTitle(tracker);
      if (!title) return;
      if (h3.textContent.trim() !== title) h3.textContent = title;
      if (h3.__ss) return;
      h3.__ss = true;
      /* appen skriver produktnavnet tilbake ved variantbytte - sett det tilbake igjen */
      new MutationObserver(function () {
        if (h3.textContent.trim() !== title) h3.textContent = title;
      }).observe(h3, { childList: true, characterData: true, subtree: true });
    });
  }

  function closePh(modal) {
    if (modal.__ssClosing) return;
    var done = function () {
      modal.__ssClosing = false;
      modal.classList.remove('ss-closing');
      modal.style.display = 'none';
      /* Ikke laas opp hvis cart-skuffen staar aapen - de deler document.body.style.overflow, og
         maalt nullet den ene den andres laas saa siden rullet bak et aapent panel. */
      if (!document.querySelector('#g-cart-content.g-cart-open')) document.body.style.overflow = '';
    };
    modal.__ssClosing = true;
    modal.classList.add('ss-closing');
    setTimeout(done, isPhone() ? PANEL_MS : POP_MS);
  }

  document.addEventListener('click', function (e) {
    var modal = e.target.closest && e.target.closest('.price-history-modal');
    if (!modal) return;
    var hit = e.target.closest('.modal-close') || e.target.closest('.modal-overlay') || e.target === modal;
    if (!hit) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    closePh(modal);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.price-history-modal[style*="flex"]');
    if (!open) return;
    e.stopImmediatePropagation();
    closePh(open);
  }, true);

  /* ======================================================================
     3) Judge.me: «Skriv en anmeldelse»
     ----------------------------------------------------------------------
     Se den lange kommentaren i assets/ss-overlay.css, seksjon 6, for hvorfor dette ser ut som det
     gjoer. Kort: hele visualViewport-maalingen av tastaturhoeyden er FJERNET 24.09.2026. Den maalte
     zoom like mye som tastatur (maalt: 102px «tastatur» ved zoom 1,143 uten at noe tastatur fantes),
     og zoomen kom fra vaar egen 14px-feil. Naa loeses tastaturet av geometri i CSS i stedet, og her
     ligger bare de tre tingene CSS ikke kan gjoere.
     ====================================================================== */
  var phone = window.matchMedia('(max-width:767px)');

  /* ---- 3a) jQuery-fadingen ------------------------------------------------
     Aapning og lukking av modalen er jQuery fadeIn/fadeOut paa ~400 ms. Det er en inline
     opacity-rampe, ikke CSS, saa stilarket naar den ikke. Judge.me har sin egen jQuery-instans
     paa window.jdgm.jQuery; fx.off slaar av jQuery-animasjon for den instansen.
     NB: bryteren er global for Judge.me, saa den paavirker ogsaa anmeldelseslista og
     medialightboksen - de skal fortsatt virke, bare uten fade. Alt staar i try/catch og pollingen
     gir opp etter 20 s: bytter appen navn paa instansen, faar vi bare dagens oppfoersel tilbake,
     ikke en JS-feil. */
  (function () {
    /* INGEN tidsgrense. Foerste versjon ga opp etter 20,5 s, og paa Slow 3G var Judge.me sin jQuery
       maalt fortsatt ulastet etter 42 s - da var 430 ms-fadingen fullt tilbake for kunder paa treg
       linje. Et 500 ms-intervall koster ingenting, og det stopper naar det lykkes. */
    function av() {
      try {
        var jq = window.jdgm && window.jdgm.jQuery;
        if (jq && jq.fx) { jq.fx.off = true; return true; }
      } catch (e) { return true; }   /* bytter appen navn paa instansen: dagens oppfoersel, ingen feil */
      return false;
    }
    if (!av()) {
      var t = setInterval(function () { if (av()) clearInterval(t); }, 500);
      /* og uansett i det oeyeblikket noen faktisk aapner skjemaet */
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.jdgm-write-rev-link')) av();
      }, true);
    }
  })();

  /* ---- 3b) «Hopp over» paa bildesteget ------------------------------------
     Bildet er valgfritt, men knappen sa «Neste» - da ser det ut som man maa laste opp noe.
     Teksten byttes bare saa lenge ingen fil er valgt. Ordet ligger i --ss-skip med norsk fallback,
     samme opplegg som «(valgfritt)»: maa oversettes foer utrulling til de andre butikkene. */
  /* Tom hvis --ss-skip ikke er satt i butikkens layout/theme.liquid. Da beholder knappen appens
     egen tekst, som allerede er oversatt. «Hopp over» skal aldri dukke opp i en dansk butikk. */
  function skipLabel() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--ss-skip').trim();
    return v ? v.replace(/^["']|["']$/g, '') : '';
  }

  function syncSkip() {
    var page = document.querySelector('.jdgm-write-review-modal__page--share-media');
    if (!page) return;
    var section = page.closest('.jdgm-write-review-modal__section');
    var btns = section ? section.querySelectorAll('.jdgm-write-review-modal__navigation button') : [];
    var btn = btns[btns.length - 1];
    if (!btn) return;
    var previews = page.querySelector('.jdgm-write-review-modal__media-previews-container');
    var hasMedia = !!previews && previews.children.length > 0;
    if (btn.__ssLabel === undefined) btn.__ssLabel = btn.textContent.trim();
    var skip = skipLabel();
    var want = (skip && page.classList.contains('current-page') && !hasMedia) ? skip : btn.__ssLabel;
    if (btn.textContent.trim() !== want) btn.textContent = want;
  }

  /* ---- 3c) smaaskriften under knappene paa mobil --------------------------
     Kan ikke gjoeres med CSS order: avsnittet ligger inne i .__form (i sida), mens knappene ligger
     i .__section ved siden av .__slider-container - ulike foreldre. Flyttes derfor til slutten av
     .__content paa mobil, og settes tilbake der appen hadde den paa desktop. */
  function moveGdpr() {
    var g = document.querySelector('.jdgm-write-review-modal__gdpr-statement');
    var content = document.querySelector('.jdgm-write-review-modal__content');
    if (!g || !content) return;
    if (!g.__ssHome) g.__ssHome = { parent: g.parentNode, next: g.nextSibling };
    if (phone.matches) {
      if (g.parentNode !== content) content.appendChild(g);
    } else if (g.parentNode === content && g.__ssHome.parent) {
      g.__ssHome.parent.insertBefore(g, g.__ssHome.next);
    }
  }

  /* ---- 3d) scroll-laas bak modalen ----------------------------------------
     Siden bak arket rullet fritt (maalt 7269px dokument), som er en stor del av det «buggy»
     inntrykket paa mobil. Laasen ligger paa <html> som en KLASSE, ikke som inline body-stil:
     closePh() over roerer body.style.overflow for prishistorikk-modalen, og to inline-brukere av
     samme felt ville nullet hverandre ut.
     Opplaasingen skjer fra en observer, ikke fra et klikk - appen lukker modalen med
     fadeOut(..., function(){ $modal.remove() }). Maalt 24.09.2026: klikk paa overlegget lukker
     IKKE denne modalen (det er appens valg, og rimelig for et skjema med skrevet tekst). De
     virkelige lukkestiene er X, Escape og innsending. Observeren ser alle tre, fordi den ser paa
     om modalen finnes og vises - ikke paa hvilket klikk som lukket den. */
  function setLock(on) {
    var root = document.documentElement;
    var laast = root.classList.contains('ss-jdgm-lock');
    if (on === laast) return;                       /* idempotent - observeren fyrer ofte */
    if (on) {
      var y = window.scrollY || window.pageYOffset || 0;
      root.setAttribute('data-ss-scroll', String(y));
      document.body.style.top = (-y) + 'px';
      root.classList.add('ss-jdgm-lock');
    } else {
      var back = parseInt(root.getAttribute('data-ss-scroll') || '0', 10) || 0;
      root.classList.remove('ss-jdgm-lock');
      document.body.style.top = '';
      root.removeAttribute('data-ss-scroll');
      window.scrollTo(0, back);                     /* tilbake dit kunden var */
    }
  }

  function syncLock() {
    var m = document.querySelector('.jdgm-write-review-modal');
    /* IKKE offsetParent: den er alltid null for position:fixed-elementer, og modalen er fixed -
       med den testen laaste vi aldri. offsetHeight + display er det som faktisk sier om den vises. */
    var open = !!m && m.offsetHeight > 0 && getComputedStyle(m).display !== 'none';
    setLock(open);
  }

  /* Siste skanse: skulle observeren av en eller annen grunn ikke se lukkingen, skal kunden aldri
     bli sittende med en butikk som ikke kan rulles. */
  window.addEventListener('pagehide', function () { setLock(false); });

  /* ---- 3e) én observer for alle tre ---------------------------------------
     Appen bygger stegene om underveis og fjerner hele modalen ved lukking, saa vi ser paa body. */
  var scheduled = false;
  function syncAll() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      try { moveGdpr(); syncSkip(); syncLock(); } catch (e) { /* aldri velt siden */ }
    });
  }

  new MutationObserver(syncAll).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'],
  });
  if (phone.addEventListener) phone.addEventListener('change', syncAll);
  syncAll();

  /* ---- Judge.me-knappen: normaliser teksten FOER den tegnes --------------
     Judge.me har knappeteksten i VERSALER i sine egne innstillinger, og ss-judgeme.js skriver den
     om ~30 ms senere - det er de 1-2 framene Kristoffer ser som et blink. Her fanges noden i samme
     mikrotask som den settes inn, saa versalene aldri naar skjermen.
     Regelen er bevisst konservativ: bare tekst som er HELT i versaler roeres, og bare foerste
     bokstav beholdes stor. Er teksten allerede riktig, skjer ingenting - saa dette er trygt ogsaa
     etter at teksten er rettet i Judge.me-admin, som er den ekte kuren. */
  function normaliserKnapp(root) {
    var els = (root && root.querySelectorAll) ? root.querySelectorAll('.jdgm-write-rev-link') : [];
    if (root && root.classList && root.classList.contains('jdgm-write-rev-link')) els = [root];
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').trim();
      if (!t || t !== t.toUpperCase() || t === t.toLowerCase()) continue;   /* ikke versaler */
      els[i].textContent = t.charAt(0) + t.slice(1).toLowerCase();
    }
  }
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i];
      if (m.type === 'characterData') { normaliserKnapp(m.target.parentElement); continue; }
      for (var j = 0; j < m.addedNodes.length; j++) {
        if (m.addedNodes[j].nodeType === 1) normaliserKnapp(m.addedNodes[j]);
      }
      if (m.target && m.target.nodeType === 1) normaliserKnapp(m.target);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  normaliserKnapp(document);

  /* ======================================================================
     4) Produktgalleriet: lazy-bilder som aldri laster ved vannrett sveip
     ----------------------------------------------------------------------
     Kristoffer 24.09.2026: sveiper man bortover i galleriet blir slidene staaende hvite, helt til
     man drar siden litt NEDOVER - da dukker de opp.
     Aarsak: bare det viste bildet lastes eager (ytelsesarbeidet 18.09: 12 bilder = 746 KB tok 4 s
     paa 4G), resten er loading="lazy". Flickity flytter sporet med transform, og nettleseren regner
     ikke ut lazy-terskelen paa nytt naar noe bare forskyves - den gjoer det ved vertikal scrolling.
     Maalt i dev: bilde 2, 6, 7 og 8 hadde naturalWidth 0 selv etter at karusellen hadde flyttet seg.
     Loesning: behold lazy ved foerste last (LCP-gevinsten er der), men gjoer ALLE bildene i galleriet
     eager i det oeyeblikket kunden roerer det. Da koster det ingenting for dem som aldri sveiper,
     og den som sveiper faar bilder med en gang.
     Hoerer strengt tatt hjemme i snippets/kalis-media.liquid eller et eget galleri-skript; ligger her
     for aa slippe en tredje runde med layout/theme.liquid i 17 temaer.
     ====================================================================== */
  /* 01.10.2026 (Kristoffer, inkognito paa iPhone): fortsatt hvite firkanter. To hull i loesningen over:
     (a) den vekket bare elementet kunden rorte. Sveip paa hovedbildet gjorde slidene eager, men
         miniatyrstripa ble staaende lazy - og naar karusellen ruller stripa til bilde 5, 6, 7 var de tomme.
     (b) bildene laster foerst NAAR kunden roerer, saa paa mobilnett kom neste slide hvit inn.
     Naa: hele galleriet (slides + miniatyrer, [data-product-images]) vekkes samlet, og i tillegg av seg
     selv like etter window.load - da er LCP ferdig, saa det stjeler ingenting fra hovedbildet.
     Synligheten (opacity, AOS-fade) styres i ss-overlay.css del «Produktgalleriet». */
  (function () {
    var SEL = '[data-product-images]';
    function vekk(g) {
      if (g.__ssEager) return;
      g.__ssEager = true;
      g.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.setAttribute('loading', 'eager');
        img.removeAttribute('fetchpriority');
      });
    }
    function bind(scope) {
      (scope || document).querySelectorAll(SEL).forEach(function (g) {
        if (g.__ssBound) return;
        g.__ssBound = true;
        ['pointerdown', 'touchstart', 'mousedown', 'click', 'keydown'].forEach(function (t) {
          g.addEventListener(t, function () { vekk(g); }, { once: true, passive: true });
        });
      });
    }
    function varm() {
      var ri = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
      ri(function () { document.querySelectorAll(SEL).forEach(vekk); }, { timeout: 1500 });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
    else bind();
    if (document.readyState === 'complete') varm();
    else window.addEventListener('load', varm, { once: true });
    /* temaeditoren og variantbytte bygger galleriet paa nytt */
    document.addEventListener('shopify:section:load', function (e) { bind(e.target); varm(); });
  })();

  /* ======================================================================
     5) Store overskrifter som ikke faar plass, krympes til de faar det
     ----------------------------------------------------------------------
     Kristoffer 01.10.2026: siden kunne dras sidelengs paa mobil. Et ord kan ikke brytes, og et langt ord i
     en 32px-overskrift ble bredere enn skjermen: «Weihnachtsgeschenke» (DE) +22px paa iPhone 14, og paa
     320-360px ogsaa «Karnevalskostymer» (NO), «Fastelavnskostumer» (DK), «Födelsedagspresent» (SE),
     «Bundelaanbiedingen» og «BEOORDELINGEN» (NL), «Syntymäpäivälahja» (FI) - 1585 kolleksjonsnavn maalt.
     Regelen: en overskrift som stikker ut av boksen sin, faar mindre skrift til den passer. Alle andre er
     uroert - derfor JS og ikke CSS: CSS vet ikke hvor langt ordet er, og en fast mindre skrift ville
     krympet alle overskrifter. Orddeling ble proevd: WebKit delte «Weihnachtsgeschen-ke».
     ====================================================================== */
  (function () {
    var SEL = 'h1.section-header__title, h2.section-header__title, .agency-testimonials .title_stars';
    /* hvor mange px teksten stikker ut av innholdsboksen (0 = den passer) */
    function ut(el) {
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      var l = r.left + parseFloat(cs.paddingLeft), h = r.right - parseFloat(cs.paddingRight);
      var rg = document.createRange(); rg.selectNodeContents(el);
      var rs = rg.getClientRects(), m = 0;
      for (var i = 0; i < rs.length; i++) if (rs[i].width) m = Math.max(m, rs[i].right - h, l - rs[i].left);
      return m;
    }
    function tilpass(el) {
      el.style.fontSize = ''; el.style.lineHeight = '';
      if (!el.offsetWidth || ut(el) < 0.5) return;
      var cs = getComputedStyle(el), fs = parseFloat(cs.fontSize), lh = parseFloat(cs.lineHeight) / fs;
      var boks = el.getBoundingClientRect().width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      for (var n = 0, forrige = Infinity; n < 8 && fs > 14; n++) {
        var o = ut(el); if (o < 0.5) break;
        /* teksten blir ikke smalere (fast px-stoerrelse eller !important inni) - gi opp, la den vaere som foer */
        if (o > forrige - 0.25) { el.style.fontSize = ''; el.style.lineHeight = ''; break; }
        forrige = o;
        fs = Math.max(14, Math.floor(fs * boks / (boks + o) * 2) / 2);   /* ned til naermeste halve px */
        el.style.fontSize = fs + 'px';
        if (lh) el.style.lineHeight = (lh * fs).toFixed(2) + 'px';
      }
    }
    function alle() { document.querySelectorAll(SEL).forEach(tilpass); }
    var b0 = window.innerWidth, t;
    alle();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(alle);   /* skriften lastes etter */
    window.addEventListener('load', alle, { once: true });
    window.addEventListener('resize', function () {
      if (window.innerWidth === b0) return;   /* adresselinja paa iOS endrer bare hoeyden */
      b0 = window.innerWidth; clearTimeout(t); t = setTimeout(alle, 150);
    });
    document.addEventListener('shopify:section:load', alle);
  })();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setHeads);
  else setHeads();
  /* appen bygger trackeren på nytt ved variantbytte */
  setTimeout(setHeads, 1200);
  document.addEventListener('shopify:section:load', setHeads);
})();
